import { asyncActionsCreator } from "@webiz/redux-common";
import {
  GET_USERS,
  GET_USERS_DATE,
  RESET_USERS_STATE,
  GET_USERS_DETAILS
} from "./UsersTypes";

export const getUsersActions = asyncActionsCreator(GET_USERS);
export const getUsersDetailsActions = asyncActionsCreator(GET_USERS_DETAILS);
export const getUsersDate = asyncActionsCreator(GET_USERS_DATE);
export const resetUsersStateAction = asyncActionsCreator(RESET_USERS_STATE);
